var parse = require("./parse.js"),
    compile = require("./compile.js");

module.exports = function nthCheck(formula){
	return compile(parse(formula));
};

module.exports.parse = parse;
module.exports.compile = compile;


//////////////////
// WEBPACK FOOTER
// ./~/nth-check/index.js
// module id = 4345
// module chunks = 168707334958949